import { postData, getData, putData, deleteData } from '../axiosServices'

export const getAllLabs = async () => {
    let url = `labs`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getLabById = async (id) => {
    let url = `labs/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const getLabType = async () => {
    let url = `labs/labType`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const createLab = (data) => {
    let url = 'labs'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, data, { headers })
}
export const updateLab = async (id, data) => {
    let url = `labs/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
};
export const disableLab = async (labId) => {
    let url = `labs/${labId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return deleteData(url, { headers });
};
export const getAllAttendanceRecords = async () => {
    let url = `labDailyAttendance`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};
export const createAttendance = (data) => {
    let url = 'labDailyAttendance'
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, data, { headers })
}
export const updateAttendance = async (id, data) => {
    let url = `labDailyAttendance/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers })
};
export const downloadQrCode = async (attendanceId) => {
    let url = `labDailyAttendance/qrCode/${attendanceId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, {}, { headers, responseType: 'blob' })

}
export const disableAttendance = async (attendanceId) => {
    let url = `labDailyAttendance/${attendanceId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }

    return deleteData(url, { headers });
};
export const refreshAttendance = async (id) => {
    let url = `labDailyAttendance/refresh-attendance-code/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers })
};
export const getAttendanceById = async (id) => {
    let url = `labDailyAttendance/${id}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

export const activateAttendance = async (attendanceId) => {
    let url = `labDailyAttendance/${attendanceId}/toggle-status`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers })
}

export const getLearnersByCoeAndLab = async (coeId, labId) => {
    let url = `learners/${coeId}/${labId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return getData(url, { headers });
};

export const updateLearnerMentor = async (learnerId, data) => {
    let url = `learners/update-details/${learnerId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, data, { headers });
};

export const unmarkAttendance = async (learnerId) => {
    let url = `learnerDailyAttendance/unmarkbymentor/${learnerId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return putData(url, {}, { headers });
};

export const markAttendance = async (learnerId) => {
    let url = `learnerDailyAttendance/checkinbymentor/${learnerId}`;
    const headers = {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }
    return postData(url, {}, { headers });
};